import * as local from './local';
import * as session from './session';

export const storage = { session, local };

export default storage;
